<template>
  <div class="containers">
    <div class="output-area">
      <div ref="mathOutput"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LatexRenderer',
  props: {
    // 接收父组件传来的 LaTeX 内容
    content: {
      type: String,
      default: '',
    },
  },
  watch: {
    // 监听 content 的变化
    content: {
      immediate: true, // 组件创建时立即执行
      handler(newValue) {
        this.updateRender(newValue)
      },
    },
  },
  mounted() {
    // 初始渲染
    this.updateRender(this.content)
  },
  methods: {
    updateRender(content) { 
      // 使用 nextTick 确保 DOM 更新完成
      this.$nextTick(() => {
        if (this.$refs.mathOutput) {
          this.$refs.mathOutput.innerHTML = content
          if (window.MathJax) {
            window.MathJax.typesetPromise([this.$refs.mathOutput]).catch(
              (err) => console.error('渲染错误:', err)
            )
          }
        }
      })
    },
  },
}
</script>

<style scoped>
::v-deep mjx-container[jax='CHTML'][display='true'] {
  text-align: left !important;
}
.containers {
  /* 样式定义 */
}

.output-area {
  height: 100%;
  /* 其他样式 */
}

.output-area div {
  padding: 5px;
  background: #f8f9fa;
  text-align: left;
}
</style>
